import * as registeredBlocks from './registered.js';
export const getRecommendedRegisteredBlocks = (intl) => {
    return Object.values(registeredBlocks).reduce((acc, currentBlockFactory) => {
        const currentBlock = currentBlockFactory(intl);
        return Object.assign(Object.assign({}, acc), { [currentBlock.recommendedName]: currentBlock });
    }, {});
};
//# sourceMappingURL=recommended.js.map